<template>
    <v-main :class="$options.name">
        <v-container fluid>
            <transition name="fade" mode="out-in" appear @before-enter="beforeEnter" @after-enter="afterEnter">
                <router-view :entering="entering" />
            </transition>
        </v-container>
    </v-main>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
    name: 'TheContentPane',
})
export default class TheContentPane extends Vue {
    entering: boolean = false;

    beforeEnter() {
        this.entering = true;
    }
    afterEnter() {
        this.entering = false;
    }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.TheContentPane {
    min-height: 100vh;
}
</style>
